<script>
    /**
     * 下拉选择
     */
    import CheckBox from './CheckBox.vue';
    import NormalInput from './NormalInput.vue';
    import NormalScrollbar from './NormalScrollbar.vue';
    import { hideOptsMixin } from '../mixin';

    export default {
        mixins: [ hideOptsMixin ],

        name: 'multiple-select',
        data () {
            return {
                keyword: '',
                checkedAll: false,
                optionList: this.$util.deepCopy(this.options),
                droped: false,
                dropX: 0,
                dropY: 0,
                minWidth: 1,
                tempSelected: {
                    text: '',
                    value: '',
                },
                hovering: false,
                orginOpts: this.options,
                prevSelected: [],
            };
        },
        watch: {
            options (val) {
                this.optionList = this.$util.deepCopy(this.options);
                this.orginOpts = val;
            },
            selected: {
                handler: function (e) {
                    this.selectedItem = this.getSelected();
                    if (!e || !e.length || !this.optionList.length) {
                        this.checkedAll = false;
                    } else {
                        this.checkedAll = this.optionList.every(
                            (item) => item.checked
                        );
                    }
                },
                immediate: true,
            },
        },
        computed: {
            curStyle () {
                return {
                    'margin-left':
                        this.marginLeft * this.$cStyle.horizonMargin + 'px',
                    'margin-right':
                        this.marginRight * this.$cStyle.horizonMargin + 'px',
                    float: this.float,
                };
            },
            selectedItem: {
                get: function () {
                    return this.getSelected();
                },
                set: function () {},
            },
            dropStyle () {
                return {
                    left: this.dropX + 'px',
                    top: this.dropY + 'px',
                    position: this.position,
                    'min-width': this.minWidth + 'px',
                };
            },
            choosedOptList () {
                let selected = this.tempSelected.value.split(',');
                return this.orginOpts.filter((item) => {
                    return selected.indexOf(String(item.value)) !== -1;
                });
            },
        },
        props: {
            placeholder: {
                default: '请选择',
                required: false,
            },
            hoverTitle: {
                type: Boolean,
                default: false,
                required: false,
            },
            withSearch: {
                type: Boolean,
                default: false,
                required: false,
            },
            inputPlaceholder: {
                default: '搜索关键词',
                required: false,
            },
            optionHeight: {
                default: 300,
                required: false,
            },
            options: {
                default () {
                    return [];
                },
                required: false,
            },
            direction: {
                default: 'bottom',
                required: false,
            },
            selected: {
                default: null,
                required: false,
            },
            theme: {
                default: 'grey',
                required: false,
            },
            marginLeft: {
                default: 0,
                required: false,
            },
            marginRight: {
                default: 0,
                required: false,
            },
            float: {
                default: 'left',
                required: false,
            },
            disabled: {
                type: Boolean,
                default: false,
                required: false,
            },
            position: {
                default: 'absolute',
                required: false,
            },
            customMulitText: {
                default: '',
                required: false,
            },
            sampleText: {
                type: String,
                default: '',
                required: false,
            },
            limitShow: {
                type: Number,
                default: 2,
                required: false,
            },
            separation: {
                type: String,
                default: ',',
                required: false,
            },
            showCheckedAll: {
                type: Boolean,
                default: false,
                required: false,
            },
            checkedAllText: {
                type: String,
                default: '',
                required: false,
            },
            textWidth: {
                type: Number,
                default: -1,
                required: false,
            },
            showChoosed: {
                type: Boolean,
                default: false,
                required: false,
            },
            searchWay: {
                type: String,
                default: 'input',
                required: false,
            },
            customOptionClass: {
                type: String,
            },
            isLoading: {
                type: Boolean,
                default: true,
                required: false,
            },
            isEnd: {
                type: Boolean,
                default: true,
                required: false,
            },
        },
        model: {
            prop: 'selected',
            event: 'change',
        },
        methods: {
            handleKeyDownSearch () {
                if (this.searchWay !== 'keydown') {
                    return;
                }
                this.handleSearch();
                this.$nextTick(() => {
                    this.computePosition();
                });
            },
            handleInput () {
                if (this.searchWay !== 'input') {
                    return;
                }
                this.handleSearch();
            },

            handleSearch () {
                if (!this.orginOpts || !this.orginOpts.length) {
                    this.orginOpts = this.optionList;
                }
                const newOpts = this.$util
                    .deepCopy(this.orginOpts)
                    .filter((val) => val.text.includes(this.keyword));
                this.optionList = newOpts.map((val) => {
                    val.orgin_text = val.text;
                    val.text = this.hightLightKw(val.text);
                    return val;
                });
            },
            hightLightKw (name) {
                if (!this.keyword) {
                    return name;
                }
                let replaceStr = '<span style=\'color:#11a1f8\'>$1</span>';
                let reg = new RegExp('(' + this.keyword + ')', 'ig');
                return name.replace(reg, replaceStr);
            },

            getSelected () {
                let selectArray = [];
                if (typeof this.selected === 'string') {
                    selectArray = this.selected.split(this.separation);
                } else if (this.selected instanceof Array) {
                    selectArray = this.selected;
                }
                for (let i = 0; i < this.orginOpts.length; i++) {
                    this.orginOpts[i].checked =
                        this.selected &&
                        selectArray.includes(String(this.orginOpts[i].value));
                }

                for (let i = 0; i < this.optionList.length; i++) {
                    this.optionList[i].checked =
                        this.selected &&
                        selectArray.includes(String(this.optionList[i].value));
                }

                const selected = this.orginOpts.filter((val) => val.checked);

                const selectText = this.getSelectedText(selected);
                const selectValue = selected.map((val) => val.value).join(',') || '';

                this.tempSelected.text = selectText;
                this.tempSelected.value = selectValue;

                let tempPrevSelected = [];
                this.options.forEach((item) => {
                    if (selectArray.includes(String(item.value))) {
                        tempPrevSelected.push(item);
                    }
                });
                this.prevSelected = tempPrevSelected;
                return this.tempSelected;
            },

            drop () {
                if (this.disabled === true) {
                    return false;
                }
                if (this.droped) {
                    this.fold();
                    return;
                }
                this.droped = true;
                const that = this;

                this.computePosition();
                //  - 28 - 2;
                this.outAreaMouseDown = function () {
                    if (that.hovering) {
                        return;
                    }
                    that.fold();
                };
                window.addEventListener('mousedown', this.outAreaMouseDown);
            },
            fold () {
                this.droped = false;
                window.removeEventListener('mousedown', this.outAreaMouseDown);
            },
            onCheck ($e, key, eventItem) {
                if (!this.droped) {
                    return;
                }
                if ($e === eventItem.checked) {
                    return;
                }
                this.optionList[key].checked = $e;
                const selected = this.optionList.filter((val) => val.checked);
                let allSelected = this.$util.deepCopy(this.prevSelected);

                if ($e === false) {
                    // 去掉选择
                    allSelected.forEach((item, index) => {
                        if (item.value === eventItem.value) {
                            allSelected.splice(index, 1);
                        }
                    });
                }

                let diffSelectd = [];
                let prevValueArray = [];
                allSelected.forEach((sItem) => {
                    prevValueArray.push(String(sItem.value));
                });

                selected.forEach((sItem) => {
                    // 当前选中的
                    if (!allSelected.length) {
                        // 之前没选中过
                        diffSelectd.push(sItem);
                    } else {
                        if (!prevValueArray.includes(String(sItem.value))) {
                            diffSelectd.push(sItem);
                        }
                    }
                });

                allSelected = allSelected.concat(diffSelectd);
                this.prevSelected = this.$util.deepCopy(allSelected);

                this.handleEmit(allSelected);

                return false;
            },
            getSelectedText (allSelected) {
                let selectText = this.placeholder;
                if (this.sampleText && allSelected.length > this.limitShow) {
                    if (
                        allSelected.length === this.optionList.length &&
                        this.checkedAllText
                    ) {
                        selectText = this.checkedAllText;
                    } else {
                        selectText = `已选择${ allSelected.length }个${
                            this.sampleText
                        }`;
                    }
                } else if (allSelected.length) {
                    selectText = allSelected
                        .map((item) => item.orgin_text || item.text)
                        .join(',');
                }
                return selectText;
            },
            handleEmit (allSelected) {
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.checkedAll =
                        allSelected.length ===
                        (this.orginOpts.length ? this.orginOpts : this.optionList)
                            .length;
                    this.$set(
                        this.selectedItem,
                        'text',
                        this.getSelectedText(allSelected)
                    );
                    this.$set(
                        this.selectedItem,
                        'value',
                        allSelected.map((item) => item.value).join(this.separation)
                    );
                    this.$emit('select', this.selectedItem);
                    this.$emit('change', this.selectedItem.value);
                });
            },
            handleCheckAll ($e) {
                if (!this.showCheckedAll) return;
                this.checkedAll = $e;
                if ($e || (!$e && this.optionList.every((v) => v.checked))) {
                    for (let i = 0; i < this.optionList.length; i++) {
                        this.$set(this.optionList[i], 'checked', $e);
                    }
                    for (let i = 0; i < this.orginOpts.length; i++) {
                        this.$set(this.orginOpts[i], 'checked', $e);
                    }
                    this.prevSelected = $e ? this.$util.deepCopy(this.optionList) : [];
                }
                const selected = this.optionList.filter((val) => val.checked);
                this.handleEmit(selected, undefined);
            },
            cancelChoosed (item) {
                let selected = this.tempSelected.value.split(',');
                selected.splice(
                    selected.findIndex((selItem) => {
                        return selItem == item.value;
                    }),
                    1
                );
                this.tempSelected.value = selected.join(',');
                let allSelected = this.orginOpts.filter((item, index) => {
                    return selected.indexOf(String(item.value)) !== -1;
                });
                this.handleEmit(allSelected);
            },
            computePosition () {
                this.$refs.optionList.style.opacity = 0;
                this.$nextTick(() => {
                    const rect = this.$el.getBoundingClientRect();
                    const optRect = this.$refs.optionList.getBoundingClientRect();
                    this.dropX =
                        Math.round(rect.left) +
                        (window.pageXOffset || window.pageXOffset);
                    // const optRealH = this.options.length * 36 < this.optionHeight ? this.options.length * 36 : this.optionHeight;
                    const optRealH = optRect.height;
                    if (this.direction === 'top') {
                        this.dropY =
                            Math.round(rect.top) +
                            (window.pageYOffset || window.pageYOffset) -
                            (optRealH + 20);
                    } else if (this.direction === 'auto') {
                        let btmBlankH = null;
                        if (window.innerHeight) {
                            btmBlankH = window.innerHeight - rect.top;
                        }

                        if (btmBlankH && btmBlankH > optRealH + 20) {
                            // 20为预留多余空白
                            this.dropY =
                                Math.round(rect.top) +
                                44 +
                                (window.pageYOffset || window.pageYOffset);
                        } else {
                            this.dropY =
                                Math.round(rect.top) +
                                (window.pageYOffset || window.pageYOffset) -
                                (optRealH + 20);
                        }
                    } else {
                        this.dropY =
                            Math.round(rect.top) +
                            44 +
                            (window.pageYOffset || window.pageYOffset);
                    }
                    this.minWidth = Math.round(rect.width);
                    setTimeout(() => {
                        this.$refs.optionList.style.opacity = 1;
                    }, 100);
                });
            },
            handleScroll () {
                let {
                    scrollTop,
                    clientHeight,
                    scrollHeight,
                } = this.$refs.div_scrollbar.$refs.scrollWrap;
                let isScrollEnd = scrollTop + clientHeight >= scrollHeight;
                if (isScrollEnd && !this.isEnd && !this.isLoading)
                    this.$emit('scrollEnd');
            },
        },
        beforeDestroy () {
            document.body.removeChild(this.$refs.optionList);
        },
        components: {
            CheckBox,
            NormalInput,
            NormalScrollbar,
        },
        mounted () {
            document.body.appendChild(this.$refs.optionList);

            const selectArray = this.selected ? this.selected.split(',') : [];
            let tempPrevSelected = [];
            this.options.forEach((item) => {
                if (selectArray.includes(String(item.value))) {
                    tempPrevSelected.push(item);
                }
            });
            this.prevSelected = tempPrevSelected;

            this.$bus.$on('cancelMultipleSelect', () => {
                this.prevSelected = [];
            });
        },
    };
</script>

<template>
    <div
        class="drop-frame"
        @mouseenter="hovering = true"
        @mouseleave="hovering = false"
        @click.stop="drop"
        v-bind:class="[theme, { disabled: disabled }]"
        v-bind:style="curStyle"
    >
        <!--<normal-input v-if="optionList.length > 0"-->
        <!--:readonly="true"-->
        <!--float="none"-->
        <!--:disabled="disabled"-->
        <!--suffix-icon="&#xe69e;"-->
        <!--v-model="selectedItem.text">-->
        <!--</normal-input>-->
        <div
            class="selected"
            :class="{'empty': !selected}"
            @click.stop="drop"
            :title="
                hoverTitle
                    ? customMulitText || selectedItem.text || placeholder
                    : ''
            "
        >
            {{ customMulitText || selectedItem.text || placeholder }}
        </div>
        <div class="show-choosed" v-if="showChoosed">
            <div
                class="show-choosed-item"
                v-for="(choosedItem, choosedIndex) in choosedOptList"
                :key="'choosed' + choosedIndex"
                @click.stop="cancelChoosed(choosedItem)"
            >
                <span class="icon">&#xe7c5;</span>
                <span>{{ choosedItem.text }}</span>
            </div>
        </div>
        <transition name="fade">
            <div
                class="option-list"
                ref="optionList"
                v-show="droped"
                @mousedown.stop
                :class="{
                    'with-search': withSearch,
                    [customOptionClass]: !!customOptionClass,
                }"
                v-bind:style="dropStyle"
            >
                <div class="search-bar" v-if="withSearch">
                    <normal-input
                        class="search-input"
                        v-model="keyword"
                        @input="handleInput"
                        @suffixClick="handleKeyDownSearch"
                        @keydown.native.enter="handleKeyDownSearch"
                        float="none"
                        type="text"
                        autocomplete="off"
                        suffix-icon="&#xe686;"
                        :placeholder="inputPlaceholder"
                    ></normal-input>
                </div>

                <normal-scrollbar
                    :height="optionHeight"
                    @scroll="handleScroll"
                    ref="div_scrollbar"
                >
                    <div
                        class="item"
                        v-if="showCheckedAll && !keyword"
                        @mousedown.stop
                    >
                        <check-box
                            class="new-width"
                            theme="grey"
                            :checked="checkedAll"
                            @check="handleCheckAll($event)"
                            @mousedown.stop
                            :textWidth="textWidth"
                            :text="checkedAll ? '全不选' : '全选'"
                        ></check-box>
                    </div>
                    <div
                        class="item"
                        v-for="(item, key) in optionList"
                        @mousedown.stop
                        :key="item.value"
                        :style="{ 'min-width': minWidth + 'px' }"
                    >
                        <check-box
                            class="new-width"
                            theme="grey"
                            :checked="item.checked"
                            @check="onCheck($event, key, item)"
                            @mousedown.stop
                            :text="item.text"
                            :textWidth="textWidth"
                        ></check-box>
                    </div>

                    <div v-if="!optionList.length" class="no-match">
                        无匹配结果
                    </div>
                </normal-scrollbar>
                <span class="isLoading" v-if="!isEnd && isLoading"
                >加载中...</span
                >
            </div>
        </transition>
    </div>
</template>

<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .drop-frame {
        width: auto;
        // height: @widgetsHeight;
        // line-height: @widgetsHeight;
        margin: (@lineHeight - @widgetsHeight)/2 0;
        cursor: pointer;
        // border: 1px @otherIptSelTipsDisbaledClr solid;
        // border-radius: @widgetsBorderRadius;
        box-sizing: border-box;

        &.disabled {
            .selected {
                background-color: @otherDisabledBgClr;
                border: 1px solid @otherBorderClr !important;

                &:hover {
                    border-color: @otherBorderClr !important;
                }
            }
        }

        .show-choosed {
            float: left;
            width: 100%;
            margin-left: -8px;
            margin-right: -8px;
            font-size: 14px;

            .show-choosed-item {
                display: inline-block;
                margin-left: 8px;
                margin-right: 8px;
                line-height: 30px;
                cursor: pointer;

                .icon {
                    // line-height: 54px;
                    font-family: 'cmsicon';
                    margin-right: 4px;
                    font-size: 18px;
                }

                span {
                    display: inline-block;
                    vertical-align: middle;
                }
            }
        }

        > .selected {
            width: auto;
            min-width: 1px;
            height: @widgetsHeight - 2;
            line-height: @widgetsHeight;
            text-align: center;
            overflow: hidden;
            padding: 0 30px 0 14px;
            margin: 0;
            position: relative;
            font-size: 14px;
            cursor: pointer;
            border: 1px @otherIptSelTipsDisbaledClr solid;
            border-radius: @widgetsBorderRadius;
            white-space: nowrap;
            text-overflow: ellipsis;
            .user-select;

            &:after {
                font-family: cmsicon;
                content: '\e69e';
                font-size: 12px;
                color: @otherTextClr;
                width: 25px;
                right: 2px;
                top: 0;
                height: 0;
                line-height: 36px;
                position: absolute;
            }
        }
    }

    .option-list {
        top: 40px;
        left: 40px;
        background-color: #fff;
        box-shadow: 0px 0px 4px 0px rgba(17, 6, 85, 0.16);
        width: auto;
        height: auto;
        min-width: 1px;
        min-height: 1px;
        overflow: auto;
        z-index: 20000;
        padding: 6px 0;
        border-radius: @widgetsBorderRadius;

        .no-match {
            line-height: 36px;
            color: #d8dadd;
            font-size: 14px;
            text-align: center;
        }

        .search-bar {
            overflow: hidden;
            width: 100%;
            padding: 0 10px;
            box-sizing: border-box;
        }

        &.with-search {
            .option-list-wrap {
                height: auto;
                max-height: 250px;
                overflow-y: auto;
            }
        }

        .new-width {
            width: 100%;
            margin: 0;
        }

        .item {
            width: auto;
            min-width: 1px;
            overflow: hidden;
            box-sizing: border-box;
            clear: both;
            margin: 0;
            height: @widgetsHeight;
            line-height: @widgetsHeight;
            padding: 0 14px;
            font-size: 14px;
            color: @otherTextClr;
            cursor: pointer;

            &.active {
                color: @primaryBg;
            }
        }

        .item:hover {
            background-color: @otherBtnHoverClr;
        }
    }

    .isLoading {
        color: @primaryBg;
        text-align: center;
        display: inline-block;
        width: 100%;
    }
</style>
